<template>
  <div class="flex items-center gap-2 p-4 font-bold">
    <span>{{ $t('assetBrowser.uploadModelGeneric') }}</span>
    <span
      class="rounded-full bg-white px-1.5 py-0 text-xxs font-inter font-semibold uppercase text-black"
    >
      {{ $t('g.beta') }}
    </span>
  </div>
</template>
